var render = function (_h,_vm) {var _c=_vm._c;return _c('span',[_vm._v("\n  "+_vm._s(_vm.$options.methods.getFormattedDateTime(_vm.props))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }